export class PageLayoutWidgetFilter {
  widgetId: string | undefined;
  filterKey: string | undefined;
  filterValue: string | undefined;
}
